/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for partner roles
 */
export var PartnerRoles;

(function (PartnerRoles) {
  PartnerRoles["JOVE_ADMIN"] = "jove-admin";
  PartnerRoles["PARTNER_ADMIN"] = "partner-admin";
  PartnerRoles["GA_ADMIN"] = "ga-admin";
})(PartnerRoles || (PartnerRoles = {}));